import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';

export interface EmptyStateProps {
  icon: React.ReactNode;
  title: string;
  description: string;
  compact?: boolean;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  icon,
  title,
  description,
  compact = false
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        textAlign: 'center',
        py: compact ? 4 : 8,
        px: 2,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <Box
        sx={{
          width: compact ? 36 : 48,
          height: compact ? 36 : 48,
          borderRadius: '50%',
          background:
            theme.palette.mode === 'dark'
              ? 'rgba(255,255,255,0.04)'
              : 'rgba(0,0,0,0.04)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mb: 2,
          color: theme.palette.mode === 'dark' 
            ? 'rgba(255,255,255,0.3)' 
            : 'rgba(0,0,0,0.25)',
          '& svg': {
            fontSize: compact ? 18 : 22
          }
        }}
      >
        {icon}
      </Box>
      <Typography
        sx={{
          fontSize: compact ? '14px' : '15px',
          fontWeight: 500,
          color: theme.palette.text.secondary,
          mb: 0.5
        }}
      >
        {title}
      </Typography>
      <Typography
        sx={{
          fontSize: compact ? '12px' : '13px',
          color: theme.palette.text.secondary,
          maxWidth: 320,
          mx: 'auto',
          lineHeight: 1.5,
          opacity: 0.8
        }}
      >
        {description}
      </Typography>
    </Box>
  );
};

export default EmptyState;

